// deps
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import Seo from "../../components/Seo";

// containers
import AuthPasswordResetStep1 from "../../containers/Auth/PasswordReset/Step1";
import AuthPasswordResetStep2 from "../../containers/Auth/PasswordReset/Step2";

export default function Page(props) {
  const intl = useIntl();

  const { query } = useRouter();

  const { token, email } = query;

  const step = token && email ? "step2" : "step1";

  return (
    <>
      <Seo
        title={intl.formatMessage({
          defaultMessage: "Réinitialisation de votre mot de passe",
        })}
      />

      {"step1" === step && <AuthPasswordResetStep1 />}

      {"step2" === step && (
        <AuthPasswordResetStep2
          token={token?.toString?.()}
          email={email?.toString?.()}
        />
      )}
    </>
  );
}

Page.getInitialProps = async function () {
  return {
    layout: "signedOut",
  };
};
